"use strict";
function getFunctionName(v) {
    if (v.name) {
        return v.name;
    }
    else {
        var name_1 = v.toString();
        var match = name_1.match(/^function\s*([^\s(]+)/);
        return match ? match[1] : "Anonymous function: " + name_1;
    }
}
exports.getFunctionName = getFunctionName;



//////////////////
// WEBPACK FOOTER
// ./~/inversify/lib/utils/utils.js
// module id = 23
// module chunks = 0